// Equipment i18n — AutoScout24 has a finite, standardized equipment vocabulary,
// but each listing is scraped in its source-domain language (FR on .be/fr, NL on
// .nl, DE on .de…). This dictionary normalises any of those into the viewer's UI
// language so the fiche never mixes languages.
//
// Each row = [fr, nl, de, en]. Reverse lookup indexes ALL four columns, so a
// Dutch or German source label resolves to the same entry. Unknown terms and
// UI languages other than fr/nl/de/en fall back to EN → FR → the original.

const ROWS = [
  // ── Confort ──────────────────────────────────────────────────────────────
  ["Climatisation", "Airconditioning", "Klimaanlage", "Air conditioning"],
  ["Climatisation automatique", "Automatische klimaatregeling", "Klimaautomatik", "Automatic climate control"],
  ["Climatisation automatique, bi-zone", "2-zone automatische airco", "2-Zonen-Klimaautomatik", "2-zone climate control"],
  ["Climatisation automatique, 3 zones", "3-zone automatische airco", "3-Zonen-Klimaautomatik", "3-zone climate control"],
  ["Climatisation automatique, 4 zones", "4-zone automatische airco", "4-Zonen-Klimaautomatik", "4-zone climate control"],
  ["Accoudoir", "Armsteun", "Armlehne", "Armrest"],
  ["Aides au stationnement", "Parkeerhulp", "Einparkhilfe", "Parking assist"],
  ["Capteurs d'aide au stationnement arrière", "Parkeerhulp achter", "Einparkhilfe hinten", "Rear parking sensors"],
  ["Capteurs d'aide au stationnement avant", "Parkeerhulp voor", "Einparkhilfe vorne", "Front parking sensors"],
  ["Caméra d'aide au stationnement", "Parkeerhulp met camera", "Einparkhilfe mit Kamera", "Parking camera"],
  ["Système d'aide au stationnement automatique", "Parkeerhulp automatisch", "Automatische Einparkhilfe", "Automatic parking assist"],
  ["Vitres électriques", "Elektrische ramen", "Elektrische Fensterheber", "Electric windows"],
  ["Direction assistée", "Stuurbekrachtiging", "Servolenkung", "Power steering"],
  ["Ordinateur de bord", "Boordcomputer", "Bordcomputer", "On-board computer"],
  ["Rétroviseurs latéraux électriques", "Elektrische zijspiegels", "Elektrische Außenspiegel", "Electric side mirrors"],
  ["Rétroviseur intérieur anti-éblouissement automatique", "Automatisch dimmende binnenspiegel", "Autom. abblendender Innenspiegel", "Auto-dimming interior mirror"],
  ["Volant multifonctions", "Multifunctioneel stuurwiel", "Multifunktionslenkrad", "Multifunction steering wheel"],
  ["Volant en cuir", "Lederen stuurwiel", "Lederlenkrad", "Leather steering wheel"],
  ["Volant chauffant", "Verwarmd stuurwiel", "Beheizbares Lenkrad", "Heated steering wheel"],
  ["Détecteur de pluie", "Regensensor", "Regensensor", "Rain sensor"],
  ["Détecteur de lumière", "Lichtsensor", "Lichtsensor", "Light sensor"],
  ["Sièges arrières 1/3 - 2/3", "Achterbank 1/3 - 2/3", "Rücksitzbank 1/3 - 2/3", "Split rear seats 1/3 - 2/3"],
  ["Start/Stop automatique", "Start/Stop-systeem", "Start-Stopp-Automatik", "Automatic start/stop"],
  ["Système de navigation", "Navigatiesysteem", "Navigationssystem", "Navigation system"],
  ["Vitres teintées", "Getinte ramen", "Getönte Scheiben", "Tinted windows"],
  ["Sièges sport", "Sportstoelen", "Sportsitze", "Sport seats"],
  ["Sièges chauffants", "Stoelverwarming", "Sitzheizung", "Heated seats"],
  ["Sièges arrière chauffant", "Stoelverwarming achter", "Sitzheizung hinten", "Heated rear seats"],
  ["Sièges électriques", "Elektrische stoelen", "Elektrische Sitze", "Electric seats"],
  ["Sièges ventilés", "Geventileerde stoelen", "Sitzbelüftung", "Ventilated seats"],
  ["Sièges massants", "Massagestoelen", "Massagesitze", "Massage seats"],
  ["Siège à réglage lombaire", "Lendensteun", "Lordosenstütze", "Lumbar support"],
  ["Siège passager repliable", "Neerklapbare passagiersstoel", "Umklappbarer Beifahrersitz", "Folding passenger seat"],
  ["Réglage électrique du siège arrière", "Elektrisch verstelbare achterbank", "Elektrisch verstellbarer Rücksitz", "Electric rear seat adjustment"],
  ["Pare-brise chauffant", "Verwarmde voorruit", "Beheizbare Frontscheibe", "Heated windscreen"],
  ["Dispositif mains libres", "Handsfree", "Freisprecheinrichtung", "Hands-free system"],
  ["Commande vocale", "Spraakbediening", "Sprachsteuerung", "Voice control"],
  ["Éclairage d'ambiance", "Sfeerverlichting", "Ambientebeleuchtung", "Ambient lighting"],
  ["Frein de stationnement électronique", "Elektronische parkeerrem", "Elektronische Parkbremse", "Electronic parking brake"],
  ["Ecran tactile", "Touchscreen", "Touchscreen", "Touchscreen"],
  ["Écran multifonction entièrement numérique", "Volledig digitaal instrumentenpaneel", "Volldigitales Kombiinstrument", "Fully digital instrument cluster"],
  ["Palettes de changement de vitesses", "Schakelpaddles", "Schaltwippen", "Paddle shifters"],
  ["Verrouillage centralisé sans clé", "Keyless Entry", "Schlüssellose Zentralverriegelung", "Keyless entry"],
  ["Verrouillage centralisé avec télécommande", "Centrale vergrendeling met afstandsbediening", "Zentralverriegelung mit Fernbedienung", "Remote central locking"],
  ["Verrouillage centralisé", "Centrale vergrendeling", "Zentralverriegelung", "Central locking"],
  ["Hotspot Wi-Fi", "Wifi-hotspot", "WLAN-Hotspot", "Wi-Fi hotspot"],
  ["Toit ouvrant", "Open dak", "Schiebedach", "Sunroof"],
  ["Toit panoramique", "Panorama dak", "Panoramadach", "Panoramic roof"],
  ["Hayon arrière électrique", "Elektrische achterklep", "Elektrische Heckklappe", "Electric tailgate"],
  ["Trappe à ski", "Skiluik", "Durchladeeinrichtung", "Ski hatch"],
  ["Chargeur smartphone à induction", "Draadloze smartphonelader", "Induktive Ladefunktion", "Wireless smartphone charging"],
  ["Sellerie cuir", "Lederen bekleding", "Lederausstattung", "Leather upholstery"],
  ["Porte-bagages", "Dakdragers", "Dachreling", "Roof rails"],
  ["Séparateur pour coffre", "Bagageruimtescheiding", "Trennnetz", "Cargo divider"],
  ["Chauffage auxiliaire", "Standkachel", "Standheizung", "Auxiliary heating"],
  ["Suspension pneumatique", "Luchtvering", "Luftfederung", "Air suspension"],
  ["Suspension sport", "Sportonderstel", "Sportfahrwerk", "Sport suspension"],
  ["Régulateur de vitesse", "Cruise control", "Tempomat", "Cruise control"],
  ["Régulateur de distance", "Adaptieve cruise control", "Abstandsregeltempomat", "Adaptive cruise control"],
  ["Affichage tête haute", "Head-up display", "Head-up-Display", "Head-up display"],
  ["Porte coulissante droite", "Schuifdeur rechts", "Schiebetür rechts", "Sliding door right"],

  // ── Sécurité ─────────────────────────────────────────────────────────────
  ["ABS", "ABS", "ABS", "ABS"],
  ["ESP", "ESP", "ESP", "ESP"],
  ["Isofix", "Isofix", "Isofix", "Isofix"],
  ["Airbag conducteur", "Airbag bestuurder", "Fahrerairbag", "Driver airbag"],
  ["Airbag passager", "Airbag passagier", "Beifahrerairbag", "Passenger airbag"],
  ["Airbag avant", "Voorairbag", "Frontairbag", "Front airbag"],
  ["Airbag arrière", "Achter airbag", "Heckairbag", "Rear airbag"],
  ["Airbags latéraux", "Zijairbags", "Seitenairbags", "Side airbags"],
  ["Anti-démarrage", "Startonderbreker", "Wegfahrsperre", "Immobilizer"],
  ["Anti-patinage", "Antislipregeling", "Antriebsschlupfregelung", "Traction control"],
  ["Alarme", "Alarm", "Alarmanlage", "Alarm"],
  ["Assistant au freinage d'urgence", "Noodremassistent", "Notbremsassistent", "Emergency brake assist"],
  ["Système d'avertissement de distance", "Afstandswaarschuwing", "Abstandswarner", "Distance warning"],
  ["Système de contrôle de la pression pneus", "Bandenspanningscontrole", "Reifendruckkontrolle", "Tyre pressure monitoring"],
  ["Détection des panneaux routiers", "Verkeersbordherkenning", "Verkehrszeichenerkennung", "Traffic sign recognition"],
  ["Limiteur de vitesse", "Snelheidsbegrenzer", "Geschwindigkeitsbegrenzer", "Speed limiter"],
  ["Système de détection de la somnolence", "Vermoeidheidsdetectie", "Müdigkeitserkennung", "Drowsiness detection"],
  ["Système d'appel d'urgence", "Noodoproepsysteem", "Notrufsystem", "Emergency call system"],
  ["Assistant feux de route", "Grootlichtassistent", "Fernlichtassistent", "High beam assist"],
  ["Assistant de démarrage en côte", "Hellingassistent", "Berganfahrassistent", "Hill-start assist"],
  ["Alerte de franchissement involontaire de lignes", "Rijstrookassistent", "Spurhalteassistent", "Lane departure warning"],
  ["Feux de route non éblouissants", "Niet-verblindend grootlicht", "Blendfreies Fernlicht", "Glare-free high beam"],
  ["Avertisseur d'angle mort", "Dodehoekdetectie", "Totwinkel-Assistent", "Blind spot monitor"],
  ["Assistant de vision nocturne", "Nachtzichtassistent", "Nachtsichtassistent", "Night vision assist"],
  ["360° caméra", "360°-camera", "360°-Kamera", "360° camera"],
  ["Feux anti-brouillard", "Mistlampen", "Nebelscheinwerfer", "Fog lights"],
  ["LED phare de jour", "LED-dagrijverlichting", "LED-Tagfahrlicht", "LED daytime running lights"],
  ["Phares au LED", "LED-koplampen", "LED-Scheinwerfer", "LED headlights"],
  ["Phares de jour", "Dagrijverlichting", "Tagfahrlicht", "Daytime running lights"],
  ["Phares Full LED", "Volledige LED-koplampen", "Voll-LED-Scheinwerfer", "Full LED headlights"],
  ["Phares directionnels", "Bochtverlichting", "Kurvenlicht", "Cornering lights"],
  ["Phares laser", "Laserkoplampen", "Laserlicht", "Laser headlights"],
  ["Système de nettoyage des phares", "Koplampsproeiers", "Scheinwerferreinigung", "Headlight washers"],

  // ── Divertissement / Médias ───────────────────────────────────────────────
  ["USB", "USB", "USB", "USB"],
  ["Bluetooth", "Bluetooth", "Bluetooth", "Bluetooth"],
  ["Radio", "Radio", "Radio", "Radio"],
  ["Radio numérique", "Digitale radio", "Digitalradio", "Digital radio"],
  ["Apple CarPlay", "Apple CarPlay", "Apple CarPlay", "Apple CarPlay"],
  ["Android Auto", "Android Auto", "Android Auto", "Android Auto"],
  ["MP3", "MP3", "MP3", "MP3"],
  ["CD", "CD", "CD", "CD"],
  ["Soundsystem", "Soundsysteem", "Soundsystem", "Sound system"],
  ["Streaming audio intégré", "Geïntegreerde audiostreaming", "Integriertes Audiostreaming", "Integrated audio streaming"],
  ["Fonction TV", "Tv-functie", "TV-Funktion", "TV function"],

  // ── Autres / Extras ───────────────────────────────────────────────────────
  ["Déflecteur", "Windgeleiders", "Windabweiser", "Wind deflectors"],
  ["Pneus été", "Zomerbanden", "Sommerreifen", "Summer tyres"],
  ["Pneus tout temps saisons", "Allseizoenenbanden", "Allwetterreifen", "All-season tyres"],
  ["Pneus neige", "Winterbanden", "Winterreifen", "Winter tyres"],
  ["Pack Sport", "Sportpakket", "Sportpaket", "Sport package"],
  ["Pack hiver", "Winterpakket", "Winterpaket", "Winter package"],
  ["Jantes alliage", "Lichtmetalen velgen", "Leichtmetallfelgen", "Alloy wheels"],
  ["Jantes acier", "Stalen velgen", "Stahlfelgen", "Steel wheels"],
  ["Roue de secours", "Reservewiel", "Reserverad", "Spare wheel"],
  ["Kit de dépannage", "Bandenreparatieset", "Reparaturset", "Tyre repair kit"],
  ["Tuning", "Tuning", "Tuning", "Tuning"],
  ["Attache remorque", "Trekhaak", "Anhängerkupplung", "Tow bar"],
  ["Charge bidirectionnelle", "Bidirectioneel laden", "Bidirektionales Laden", "Bidirectional charging"],
  ["Compatible E-10", "E10-geschikt", "E10-geeignet", "E10 compatible"],
  ["Kit fumeur", "Rokerspakket", "Raucherpaket", "Smoker's package"],
  ["Pot catalytique", "Katalysator", "Katalysator", "Catalytic converter"],

  // ── Termes additionnels courants (imports futurs) ─────────────────────────
  ["Caméra de recul", "Achteruitrijcamera", "Rückfahrkamera", "Rear-view camera"],
  ["Climatisation manuelle", "Handmatige airconditioning", "Klimaanlage manuell", "Manual air conditioning"],
  ["Sièges à mémoire", "Geheugenstoelen", "Sitze mit Memory-Funktion", "Memory seats"],
  ["Feux xénon", "Xenonkoplampen", "Xenon-Scheinwerfer", "Xenon headlights"],
  ["Bi-xénon", "Bi-xenon", "Bi-Xenon", "Bi-xenon"],
  ["Phares adaptatifs", "Adaptieve koplampen", "Adaptives Kurvenlicht", "Adaptive headlights"],
  ["Différentiel autobloquant", "Sperdifferentieel", "Sperrdifferenzial", "Limited-slip differential"],
  ["Attelage escamotable", "Wegklapbare trekhaak", "Schwenkbare Anhängerkupplung", "Retractable tow bar"],
  ["Vitre arrière chauffante", "Verwarmde achterruit", "Heckscheibenheizung", "Heated rear window"],
  ["Keyless Go", "Keyless Go", "Keyless Go", "Keyless Go"],
  ["Système audio premium", "Premium audiosysteem", "Premium-Soundsystem", "Premium sound system"],
  ["Volant sport", "Sportstuur", "Sportlenkrad", "Sport steering wheel"],
];

// Category headers (also multilingual, keyed by any known name variant).
const CATEGORY_ROWS = [
  ["Confort", "Comfort & gemak", "Komfort", "Comfort & convenience",
   ["comfort en gemak", "comfortandconvenience", "comfort", "komfort & bequemlichkeit"]],
  ["Sécurité", "Veiligheid & beveiliging", "Sicherheit", "Safety & security",
   ["veiligheid en beveiliging", "safetyandsecurity", "sicherheit & schutz"]],
  ["Divertissement & médias", "Entertainment & media", "Unterhaltung & Medien", "Entertainment & media",
   ["entertainment/media", "entertainmentandmedia", "divertissement / médias", "unterhaltung/medien"]],
  ["Autres", "Extra's", "Sonstiges", "Extras",
   ["extras", "extra", "sonstige", "autre"]],
];

const LANG_IDX = { fr: 0, nl: 1, de: 2, en: 3 };

function norm(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

// Reverse index: normalized label (any language) → row.
const INDEX = new Map();
for (const row of ROWS) {
  for (let i = 0; i < 4; i++) if (row[i]) INDEX.set(norm(row[i]), row);
}
const CAT_INDEX = new Map();
for (const row of CATEGORY_ROWS) {
  for (let i = 0; i < 4; i++) if (row[i]) CAT_INDEX.set(norm(row[i]), row);
  for (const extra of row[4] || []) CAT_INDEX.set(norm(extra), row);
}

function pick(row, lang) {
  const idx = LANG_IDX[lang];
  if (idx != null && row[idx]) return row[idx];
  return row[3] || row[0]; // EN → FR fallback for es/it/pt/pl/ro
}

// Translate a single equipment label into `lang`, keeping any wheel-size suffix.
export function translateEquipment(label, lang = "fr") {
  const raw = String(label || "").trim();
  if (!raw) return raw;
  const direct = INDEX.get(norm(raw));
  if (direct) return pick(direct, lang);
  // "Jantes alliage (20")" / "Lichtmetalen velgen (20")" → translate base + keep size
  const m = raw.match(/^(.*?)(\s*\(\s*[\d.,]+\s*["″'‘’]?\s*\)|\s*\d{2}["″'‘’])\s*$/);
  if (m) {
    const base = INDEX.get(norm(m[1]));
    if (base) return pick(base, lang) + " " + m[2].trim();
  }
  return raw; // unknown term → keep as-is
}

export function translateEquipCategory(label, lang = "fr") {
  const row = CAT_INDEX.get(norm(label));
  return row ? pick(row, lang) : String(label || "");
}
